export default __webpack_public_path__ + "media/onboarding/welcome_control-3c4df211.png";